import { API } from 'api';

export const getImageUrl = (fileName: string): string => {
  return `${API}/api/containers/images/download/${fileName}`;
};
